import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { wsCreate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import { wsRemove } from 'services/WService';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const fileTypes = ['JPG', 'PNG'];

function AddressPhotoModal(props) {
  const { model, setOpen, showNotify } = props;
  const { setAddress } = props;
  const [processing, setProcessing] = useState(false);
  const [iteration, setIteration] = useState(1);

  async function handleChange(file){
    let fd = new FormData();
    fd.append('photo', file);

    setProcessing(true);
    let res = await wsCreate(`base/address/${model.base_address_id}/photo`, fd);

    if (res.success) {
      showNotify(res.message);
      let imagePath = `${res.data.file_url}?v=${iteration}`;
      setOpen({
        ...model,
        id: res.data.id,
        LineNum: res.data.LineNum,
        file_url: imagePath,
      });
      setAddress(address => {
        let newAddress = {...address};
        newAddress.photos.push({ ...res.data, file_url: imagePath });
        return newAddress;
      });
      setProcessing(false);
      setIteration((it) => it + 1);
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  async function deletePhoto() {
    setProcessing(true);
    let res = await wsRemove(`base/address/${model.base_address_id}/photo`, model.LineNum);
    if (res.success) {
      setAddress((address) => {
        let newAddress = { ...address };
        newAddress.photos = res.data;
        return newAddress;
      });
      setProcessing(false);
      setOpen({ open: false });
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="sm"
      title={
        model.id === undefined
          ? 'Nueva foto'
          : `${model.LineNum} - ${model.CardCode} - ${model.Address2}`
      }
    >
      {model.file_url !== undefined && model.file_url !== null && processing === false && (
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            minHeight: '200px',
            overflow: 'hidden',
            marginBottom: '20px',
          }}
        >
          <img src={model.file_url} style={{ width: '100%' }} />
        </div>
      )}

      {processing && (
        <div style={{ width: '350px', height: '200px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ alignSelf: 'center', width: '60px', height: '60px', marginTop: '45px' }}>
            <div className="lds-dual-ring"></div>
          </div>
        </div>
      )}

      {model.id === undefined && (
        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}>
          <FileUploader
            handleChange={handleChange}
            name="image"
            types={fileTypes}
            disabled={processing}
            label="Has click o arrastra una imagen aquí"
            hoverTitle="Suelta la imagen aquí"
            maxSize={2}
          />
        </AllowedGuard>
      )}

      {model.id !== undefined && model.file_url !== null && (
        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}>
          <RegularButton color="danger" fullWidth onClick={deletePhoto} disabled={processing}>
            Eliminar
          </RegularButton>
        </AllowedGuard>
      )}
    </ModalBase>
  );
}

export default AddressPhotoModal;
